export default __webpack_public_path__ + "static/media/burgundyDoorOpen.ec313fef.gif";